@if (!this.loading && !activo) {
  <app-breadcrumb
    listado="/main/activos/activos"
    etiquetaListado="Activos"
    [titulo]="activo?.identificacion"
  ></app-breadcrumb>
  <app-empty-state
    icon="assistant_navigation"
    message="No se encontró el activo"
  ></app-empty-state>
} @else if (!this.loading && activo) {
  <app-breadcrumb
    listado="/main/activos/activos"
    etiquetaListado="Activos"
    [titulo]="activo?.identificacion"
  ></app-breadcrumb>

  <!-- Encabezado con la misma estética que las tarjetas de la pestaña Info -->
  <header class="encabezado">
    <div class="encabezado-avatar">
      <mat-icon>assistant_navigation</mat-icon>
    </div>
    <div class="encabezado-texto">
      <h1>{{ activo.identificacion }}</h1>
      <div class="encabezado-chips">
        @if (activo.funcion) {
          <span class="chip">
            <mat-icon>category</mat-icon>
            {{ activo.funcion }}
          </span>
        }
        @if (activo.cliente?.nombre) {
          <span class="chip">
            <mat-icon>business</mat-icon>
            {{ activo.cliente.nombre }}
          </span>
        }
        @if (!activo.fechaAlta) {
          <span class="chip estado-advertencia">Sin alta</span>
        }
        @if (desactivado) {
          <span class="chip estado-advertencia">Desactivado</span>
        }
      </div>
    </div>
    <!-- Mismo permiso que pide el listado para editar -->
    @if (puedeEditar) {
      <button
        irxBotonIcono
        class="encabezado-editar"
        (click)="editar()"
        tooltip="Editar activo"
      >
        <mat-icon>edit</mat-icon>
      </button>
    }
  </header>

  <mat-tab-group
    [(selectedIndex)]="selectedTab"
    (selectedTabChange)="tabChanged($event)"
    class="tabs-detalle"
  >
    <!-- Info -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">info</mat-icon>
        <span>Info</span>
      </ng-template>
      <ng-template matTabContent>
        <app-detalles-activo-info [activo]="activo"></app-detalles-activo-info>
      </ng-template>
    </mat-tab>

    <!-- Mapa recorridos -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">route</mat-icon>
        <span>Recorridos</span>
      </ng-template>
      <ng-template matTabContent>
        <app-detalles-activo-mapa-recorrido
          [activo]="activo"
        ></app-detalles-activo-mapa-recorrido>
      </ng-template>
    </mat-tab>

    <!-- Historial de Eventos -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">report</mat-icon>
        <span>Historial Eventos</span>
      </ng-template>
      <ng-template matTabContent>
        <app-eventos-genericos-historico
          [id]="activo._id"
        ></app-eventos-genericos-historico>
      </ng-template>
    </mat-tab>

    <!-- Codigos -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">integration_instructions</mat-icon>
        <span>Códigos Eventos</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-configs-eventos
          [dispositivo]="activo"
          tipo="Activo"
          [botonCrearMostrar]="botonCrearMostrar()"
        ></app-listado-configs-eventos>
      </ng-template>
    </mat-tab>

    <!-- Eventos Personalizados -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">rule</mat-icon>
        <span>Eventos Personalizados</span>
      </ng-template>
      <ng-template matTabContent>
        @if (params) {
          <app-listado-config-evento-usuario
            [params]="params"
          ></app-listado-config-evento-usuario>
        }
      </ng-template>
    </mat-tab>

    <!-- Notas -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">note</mat-icon>
        <span>Notas</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-notas
          [idAsignado]="activo._id"
          [idCliente]="activo.idCliente"
          tipo="Nota"
          tipoDispositivo="Activo"
        ></app-listado-notas>
      </ng-template>
    </mat-tab>

    <!-- Contactos -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">contacts</mat-icon>
        <span>Contactos</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-notas
          [idAsignado]="activo._id"
          [idCliente]="activo.idCliente"
          tipo="Contacto"
          tipoDispositivo="Activo"
        ></app-listado-notas>
      </ng-template>
    </mat-tab>

    <!-- Servicio Técnico -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">build</mat-icon>
        <span>Servicio Técnico</span>
      </ng-template>
      <ng-template matTabContent>
        <app-eventos-tecnicos-genericos
          [id]="activo._id"
        ></app-eventos-tecnicos-genericos>
      </ng-template>
    </mat-tab>

    <!-- Asignaciones -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">assignment</mat-icon>
        <span>Asignaciones</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-asignacions
          [idEntidad]="activo._id"
          [tipoEntidad]="'modificada'"
        ></app-listado-asignacions>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
} @else {
  <app-detalle-esqueleto
    icono="assistant_navigation"
    listado="/main/activos/activos"
    etiquetaListado="Activos"
    [pestanas]="9"
  ></app-detalle-esqueleto>
}
